<template>
    <div class="wrapper" :class="{error}">
        <input :placeholder="placeholder" :disabled="disabled" :readonly="readonly" :value="value" type="text"
            @change="$emit('change',$event.target.value)"
            @input="$emit('input',$event.target.value)"
            @blur="$emit('blur',$event.target.value)"
            @focus="$emit('focus',$event.target.value)"
        >
        <template v-if="error">
            <Icon icon="error" class="error-icon"></Icon>
            <span class="error-message">{{error}}</span>
        </template>
    </div>
  
</template>

<script>
import Icon from './icon'
export default {
    name: 'g-input',
    components: {
        Icon
    },
    props: {
        value: {},
        disabled: {
            type: Boolean,
            default:false
        },
        readonly: {
            type: Boolean,
            default:false
        },
        error: {
            type: String
        },
        placeholder: {
            type: String,
            default:''
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'var';
.wrapper{
    font-size: $font-size;
    display:inline-flex;
    justify-content: center;
    align-items: center;
    >:not(:last-child){margin-right:.5em;}
    &.error{
        >input{
            border-color:$red;
        }
        .error-icon{
            fill:$red;
        }
        .error-message{
            color:$red;
        }
    }
    >input{
        height:$height;
        border:1px solid $border-color;
        border-radius: $border-radius;
        padding:0 8px;
        font-size: inherit;
        &:hover{
            border-color:$border-color-hover;
        }
        &:focus{
            outline: none;
            box-shadow: inset 0 1px 3px $box-shadow-color;
        }
        &[disabled]{
            border-color:#aaa;
            color:#aaa;
            cursor:not-allowed;
        }
        &[readonly]{
            border-color:#aaa;
            color:#aaa;
        }
    }
}
</style>